import createModalModel, { prop } from './lib/create_modal_model';

export default createModalModel({
  modelName: 'AddObserverToCall',
  properties: {
    conversationItemId: prop(String).isRequired,
    customerId: prop(String).isRequired,
    isAgentVisible: prop(Boolean).default(false),
  },
});
